import classNames from 'classnames'

import Icon from '@components/Icon'
import { RateCurrency } from 'shared/price-utilities'

import styles from 'booking/components/flow-steps/styles.module.scss'
import eventStyles from '../styles.module.scss'

const EventProductPriceInfo = ({ event, selectedEvent }) => (
    <div className={classNames('d-flex', 'justify-content-between', event.isSoldOut && styles.disabled)}>
        <div className={classNames(styles.radioLabelWrap)}>
            <label htmlFor="eventProduct" className={styles.radioLabel}>
                <input
                    className={styles.radioInput}
                    type="radio"
                    value={selectedEvent?.rateId === event.rateId}
                    id="eventProduct"
                />
                <div className={classNames(styles.customRadio, eventStyles.customRadioIconEvents)}>
                    <Icon type={selectedEvent?.rateId === event.rateId ? 'radiobutton-on' : 'radiobutton-off'} />
                </div>
                <div className="d-flex  flex-column">
                    <span className={classNames(styles.rateName, eventStyles.eventProductName)}>{event.eventName}</span>
                    <span className={classNames(eventStyles.rateName, event.isSoldOut && eventStyles.disabled)}>
                        {event.rateName}
                    </span>
                </div>
            </label>
        </div>
        <div className={styles.productRatesAmountWrap}>
            <span className={classNames(styles.rateAmount, 'font-weight-bold')}>
                <RateCurrency rate={event} value={event.amount} />
            </span>
            {event.isSoldOut && (
                <div className={styles.soldOutLabelContainer}>
                    <Icon type="alert" size="xs" className="mr-2" />
                    <span>
                        <T>booking.product.sold.out</T>
                    </span>
                </div>
            )}
        </div>
    </div>
)

export default EventProductPriceInfo
